import { Typography } from "@mui/material";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import RenderSurveyTable from "./RenderSurveyTable";
import {
  calculateRoomVolume,
  surveyDefaultItem,
  surveyTab1Fields,
  surveyTab1Heading,
} from "./surveyUtils";
import CustomButton from "../../../../components/common/button/CustomButton";
import { useDispatch } from "react-redux";
import { updateSurveyTabAction } from "../../../../store/reducers/leadSurveySlice";
import { useSelector } from "react-redux";

const SurveyTabForm = forwardRef<any, any>(
  (
    {
      data = {},
      elementId = 0,
      surveyForm = null,
      setSurveyForm = () => {},
      error = null,
      setError = () => {},
      tabValidator = () => {},
      setIsValueChanged = () => {},
      disabledAction = false,
      isMaterialsChanged = false,
      setIsMaterialsChanged = () => {},
      setSurveyMaterialsPayload = () => {},
    },
    ref: any,
  ) => {
    const { leadDetails } = useSelector((state: any) => state.lead);
    const { surveyedItems } = useSelector((state: any) => state.leadSurvey);
    const { user } = useSelector((state: any) => state.user);
    const isCustomer = user?.user?.roles?.[0]?.includes("CUSTOMER");
    const dispatch = useDispatch();
    const [materialsForm, setMaterialsForm]: any = useState(null);

    const materialsEntry = surveyedItems?.list?.find(
      (ele: any) => ele?.name === "Materials",
    );

    // Keep a separate, editable local copy of the Materials items so editing
    // them here never touches the current room's surveyForm.
    useEffect(() => {
      const nextMaterials = materialsEntry?.items ? [...materialsEntry.items] : [];
      setMaterialsForm(nextMaterials);
      setSurveyMaterialsPayload?.(nextMaterials);
    }, [materialsEntry, setSurveyMaterialsPayload]);

    useEffect(() => {
      if (data) {
        let createList: any = [];
        let order = 1;
        if (surveyedItems) {
          const filtered = surveyedItems?.list.find(
            (ele: any) => ele?.name === data?.room,
          );

          // createList = filtered?.items || []
          filtered?.items &&
            filtered?.items?.forEach((ele: any) => {
              createList.push({
                ...ele,
                hviValue: ele?.isHVI ? ele?.hviValue : null,
                sortOrder: order,
              });
              order++;
            });
        }
        const countLength = createList?.length;
        // order = createList ? createList?.[countLength-1]?.sortOrder : 1;
        data &&
          data?.items?.forEach((item: any, idx: any) => {
            if (idx >= countLength) {
              createList = [
                ...createList,
                {
                  ...surveyDefaultItem,
                  item: item?.name,
                  ft3: item?.ft3,
                  sortOrder: order,
                },
              ];
              order++;
            }
          });
        setSurveyForm(createList);
      }
    }, [data, elementId, setSurveyForm, surveyedItems]); //selectedLeadEstimate, show

    const onChangeAction = (event: any, index?: any, valueFormat?: any) => {
      const { id, value, checked } = event.target;
      console.log("event-67", event.target, id, value, checked);

      setSurveyForm((prevForm: any) => {
        const cloneItem = [...(prevForm || [])];
        if (cloneItem?.[index]) {
          let obj: any = {};
          if (
            id === "isLeave" ||
            id === "isWeee" ||
            id === "isCust" ||
            id === "isClear"
          ) {
            obj = {
              ...cloneItem[index],
              isLeave: false,
              isWeee: false,
              isCust: false,
              isClear: false,
              [id]: checked,
            };
          } else if (id === "isHVI") {
            obj = {
              ...cloneItem[index],
              isHVI: checked,
              hviValue: checked ? 1000 : null,
            };
          } else if (id === "isAwk" || id === "isExp" || id === "isStore") {
            obj = {
              ...cloneItem[index],
              [id]: checked,
            };
          } else {
            obj = {
              ...cloneItem[index],
              [id]:
                valueFormat === "number" && value
                  ? Number(value)
                  : valueFormat === "price" && value
                    ? value
                    : value,
            };
          }

          if (obj?.isHVI === false) {
            obj.hviValue = null;
          }

          cloneItem[index] = {
            ...obj,
          };
        }
        return cloneItem;
      });

      setIsValueChanged(true);
    };

    const onBlurAction = (event: any, index?: any, valueFormat?: any) => {
      const { id, value, checked } = event.target;

      setSurveyForm((prevForm: any) => {
        const cloneItem = [...(prevForm || [])];
        if (cloneItem?.[index]) {
          let obj: any = {};
          if (
            id === "isLeave" ||
            id === "isWeee" ||
            id === "isCust" ||
            id === "isClear"
          ) {
            obj = {
              ...cloneItem[index],
              isLeave: false,
              isWeee: false,
              isCust: false,
              isClear: false,
              [id]: checked,
            };
          } else if (id === "isHVI") {
            obj = {
              ...cloneItem[index],
              isHVI: checked,
              hviValue: checked ? 1000 : null,
            };
          } else if (id === "isAwk" || id === "isExp" || id === "isStore") {
            obj = {
              ...cloneItem[index],
              [id]: checked,
            };
          } else if (id === "hviValue" && cloneItem[index]?.isHVI === false) {
            obj = {
              ...cloneItem[index],
              hviValue: null,
            };
          } else {
            obj = {
              ...cloneItem[index],
              [id]:
                valueFormat === "number"
                  ? value
                    ? Number(value)
                    : 0
                  : valueFormat === "price"
                    ? value
                      ? Math.round(value * 100) / 100
                      : 0
                    : value,
            };
          }

          if (obj?.isHVI === false) {
            obj.hviValue = null;
          }

          cloneItem[index] = {
            ...obj,
          };
        }
        return cloneItem;
      });
    };

    const addNewRow = () => {
      setSurveyForm([
        ...surveyForm,
        {
          ...surveyDefaultItem,
          ...(isCustomer && { isNew: true }),
        },
      ]);
    };

    const removeRow = (idx: any) => {
      if (data) {
        const cloneItem = [...surveyForm];
        if (surveyedItems) {
          const filtered = surveyedItems?.list.find(
            (ele: any) => ele?.name === data?.room,
          );

          // createList = filtered?.items || []
          if (filtered?.items && filtered?.items?.[idx]) {
            cloneItem[idx] = filtered?.items?.[idx];
            //  cloneItem[idx] = {
            //   ...cloneItem[idx],
            //   ...surveyDefaultItem,
            //   item: data?.items?.[idx]?.name,
            //   ft3: data?.items?.[idx]?.ft3,
            //   quantity: 0,
            // }
          } else {
            cloneItem[idx] = {
              ...cloneItem[idx],
              ...surveyDefaultItem,
              item: data?.items?.[idx]?.name,
              ft3: data?.items?.[idx]?.ft3,
              quantity: "",
            };
          }
        } else {
          if (data?.items?.[idx]) {
            cloneItem[idx] = {
              ...cloneItem[idx],
              item: data?.items?.name,
              ft3: data?.items?.ft3,
            };
          } else {
            cloneItem[idx] = {
              ...cloneItem[idx],
              ...surveyDefaultItem,
              ft3: "",
              quantity: "",
            };
          }
        }

        setSurveyForm(cloneItem);
      }
    };

    const clearRow = (idx: any) => {
      if (data) {
        const cloneItem = [...surveyForm];
        if (surveyedItems) {
          const filtered = surveyedItems?.list.find(
            (ele: any) => ele?.name === data?.room,
          );

          // createList = filtered?.items || []
          if (filtered?.items && filtered?.items?.[idx]) {
            // cloneItem[idx] = filtered?.items?.[idx]
            cloneItem[idx] = {
              ...cloneItem[idx],
              ...surveyDefaultItem,
              item: data?.items?.[idx]?.name,
              ft3: data?.items?.[idx]?.ft3,
              quantity: 0,
              hviValue: null,
            };
          } else {
            cloneItem[idx] = {
              ...cloneItem[idx],
              ...surveyDefaultItem,
              item: data?.items?.[idx]?.name,
              ft3: data?.items?.[idx]?.ft3,
              quantity: null,
              hviValue: null,
            };
          }
        } else {
          if (data?.items?.[idx]) {
            cloneItem[idx] = {
              ...cloneItem[idx],
              item: data?.items?.name,
              ft3: data?.items?.ft3,
            };
          } else {
            cloneItem[idx] = {
              ...cloneItem[idx],
              ...surveyDefaultItem,
              ft3: "",
              quantity: null,
              hviValue: null,
            };
          }
        }
        setSurveyForm(cloneItem);
        setIsValueChanged(true);
      }
    };

    // Materials list - shown editable in every room (except the
    // "Materials" room itself, if that's ever rendered directly) so users
    // can see and update material items regardless of which room tab is
    // selected. Changes save back to the "Materials" room specifically,
    // never to the currently selected room.
    const materialsItems = materialsForm || [];
    const showMaterialsSection =
      data?.room !== "Materials" && materialsItems?.length > 0;

    const onChangeMaterialsAction = (
      event: any,
      index?: any,
      valueFormat?: any,
    ) => {
      const { id, value, checked } = event.target;

      setMaterialsForm((prevForm: any) => {
        const cloneItem = [...(prevForm || [])];
        if (cloneItem?.[index]) {
          let obj: any = {};
          if (
            id === "isLeave" ||
            id === "isWeee" ||
            id === "isCust" ||
            id === "isClear"
          ) {
            obj = {
              ...cloneItem[index],
              isLeave: false,
              isWeee: false,
              isCust: false,
              isClear: false,
              [id]: checked,
            };
          } else if (id === "isHVI") {
            obj = {
              ...cloneItem[index],
              isHVI: checked,
              hviValue: checked ? 1000 : null,
            };
          } else if (id === "isAwk" || id === "isExp" || id === "isStore") {
            obj = {
              ...cloneItem[index],
              [id]: checked,
            };
          } else {
            obj = {
              ...cloneItem[index],
              [id]:
                valueFormat === "number" && value
                  ? Number(value)
                  : valueFormat === "price" && value
                    ? value
                    : value,
            };
          }

          if (obj?.isHVI === false) {
            obj.hviValue = null;
          }

          cloneItem[index] = { ...obj };
        }
        return cloneItem;
      });

      setIsMaterialsChanged(true);
    };

    const onBlurMaterialsAction = (
      event: any,
      index?: any,
      valueFormat?: any,
    ) => {
      const { id, value, checked } = event.target;

      setMaterialsForm((prevForm: any) => {
        const cloneItem = [...(prevForm || [])];
        if (cloneItem?.[index]) {
          let obj: any = {};
          if (
            id === "isLeave" ||
            id === "isWeee" ||
            id === "isCust" ||
            id === "isClear"
          ) {
            obj = {
              ...cloneItem[index],
              isLeave: false,
              isWeee: false,
              isCust: false,
              isClear: false,
              [id]: checked,
            };
          } else if (id === "isHVI") {
            obj = {
              ...cloneItem[index],
              isHVI: checked,
              hviValue: checked ? 1000 : null,
            };
          } else if (id === "isAwk" || id === "isExp" || id === "isStore") {
            obj = {
              ...cloneItem[index],
              [id]: checked,
            };
          } else if (id === "hviValue" && cloneItem[index]?.isHVI === false) {
            obj = {
              ...cloneItem[index],
              hviValue: null,
            };
          } else {
            obj = {
              ...cloneItem[index],
              [id]:
                valueFormat === "number"
                  ? value
                    ? Number(value)
                    : 0
                  : valueFormat === "price"
                    ? value
                      ? Math.round(value * 100) / 100
                      : 0
                    : value,
            };
          }

          if (obj?.isHVI === false) {
            obj.hviValue = null;
          }

          cloneItem[index] = { ...obj };
        }
        return cloneItem;
      });
      setSurveyMaterialsPayload?.(
        (materialsForm || []).map((item: any) => ({ ...item })),
      );
    };

    const submitMaterialsHandler = () => {
      const materialsPayload = (materialsForm || [])
        .filter((item: any) => item?.item)
        .map((item: any) => ({ ...item }));

      if (!materialsPayload.length && !materialsForm?.length) {
        setIsMaterialsChanged(false);
        setSurveyMaterialsPayload?.(materialsPayload);
        return true;
      }

      dispatch(
        updateSurveyTabAction({
          tab: "tab1",
          surveyId: leadDetails?.lead?.survey_id,
          data: {
            name: "Materials",
            roomName: materialsEntry?.roomName || "Materials",
            items: materialsPayload,
          },
        }),
      );
      setIsMaterialsChanged(false);
      return true;
    };

    useImperativeHandle(ref, () => ({
      submitMaterialsHandler,
    }));

    useEffect(() => {
      if (isMaterialsChanged) {
        setSurveyMaterialsPayload?.(
          (materialsForm || []).map((item: any) => ({ ...item })),
        );
      }
    }, [isMaterialsChanged, materialsForm, setSurveyMaterialsPayload]);

    const roomVolume = calculateRoomVolume(materialsItems || []);

    return (
      <>
        <section
          style={{
            backgroundColor: "#FFF",
            padding: "0px",
            border: "1px solid #CFCFCF",
            borderRadius: "5px",
          }}
        >
          <RenderSurveyTable
            {...{
              surveyForm,
              onChangeAction,
              onBlurAction,
              error,
              tableHeadding: surveyTab1Heading,
              tableContent: surveyForm,
              fields: surveyTab1Fields,
              removeRow: data?.room === "Materials" ? null : removeRow,
              clearRow: data?.room === "Materials" ? null : clearRow,
              disabledAction: disabledAction,
              isMaterialsTab: data?.room === "Materials",
              keyName: data?.room?.replace(" ", ""),
            }}
          />
          <br />
          {!disabledAction && (
            <>
              {data?.room !== "Materials" && (
                <CustomButton
                  title="Add"
                  onClick={() => addNewRow()}
                  variant="outlined"
                  style={{ margin: "4px 10px" }}
                />
              )}
              {/* <CustomButton title="Save" onClick={() => submitHandler()} /> */}
            </>
          )}

          {/* MATERIALS - read-only section shown in every room after the
                Add button, so it's clear these items belong to Materials,
                not to the current room. */}
          {showMaterialsSection && (
            <>
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "#0F906E",
                  fontSize: "16px",
                  padding: "10px 10px 0px 10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",

                }}
              >
                Materials
                {/* RIGHT SIDE */}
                <Typography
                  sx={{
                    color: "#0F906E",
                    fontWeight: 600,
                    fontSize: "12px",
                    textTransform: "lowercase",
                    marginLeft: "8px",
                  }}
                >
                  ({roomVolume} m³)
                </Typography>
              </Typography>
              <RenderSurveyTable
                {...{
                  surveyForm: materialsItems,
                  onChangeAction: onChangeMaterialsAction,
                  onBlurAction: onBlurMaterialsAction,
                  error: null,
                  tableHeadding: surveyTab1Heading,
                  tableContent: materialsItems,
                  fields: surveyTab1Fields,
                  removeRow: null,
                  clearRow: null,
                  disabledAction: disabledAction,
                  isMaterialsTab: true,
                  keyName: "Materials",
                }}
              />
              {/* {!disabledAction && materialsChanged && (
                  <CustomButton
                    title="Save Materials"
                    onClick={() => submitMaterialsHandler()}
                    style={{ margin: "4px 10px" }}
                  />
                )} */}
            </>
          )}
        </section>
      </>
    );
  },
);

export default SurveyTabForm;
